import { Injectable } from '@angular/core';
import { fromEvent, merge, Subject, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SessionIdleService {

  private timeoutSubject = new Subject<void>();
  private idleTime = 1800 * 1000; 

  onTimeout$ = this.timeoutSubject.asObservable();

  startWatching() {

    merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click')
    )
      .pipe(
        switchMap(() => timer(this.idleTime))
      )
      .subscribe(() => {
        this.timeoutSubject.next();
      });

  }

  resetTimer() {
    document.dispatchEvent(new Event('mousemove'));
  }

}